var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVG"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.16553 6.63437L5.03353 7.76637L1.26953 4.00038L5.03353 0.234375L6.16553 1.36638L4.33153 3.20038H9.59953C11.0698 3.19775 12.482 3.77342 13.5315 4.80309C14.5809 5.83276 15.1834 7.23385 15.2087 8.70385C15.234 10.1739 14.6803 11.5949 13.6669 12.6601C12.6536 13.7253 11.262 14.3493 9.79253 14.3974L9.59953 14.4004H2.39953V12.8004H9.59953C10.6445 12.7991 11.6475 12.389 12.394 11.6577C13.1404 10.9265 13.5711 9.93212 13.5938 8.8874C13.6165 7.84268 13.2295 6.83054 12.5156 6.06749C11.8017 5.30444 10.8175 4.85108 9.77353 4.80437L9.59953 4.80037H4.33153L6.16553 6.63437Z",
    fill: "#C4CAD4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default __webpack_public_path__ + "static/media/undo.32fd6a3a2e518e98ac53ea9c3d20e393.svg";
export { ForwardRef as ReactComponent };